import React from "react";
import { Card, CardMedia, Grid, Typography } from "@mui/material";
import { getMessage, useLocale } from "../i18n/locale";
import { BANNER_IMAGE_FALLBACK, imageFallbackHandler } from "../services/profileImages";

export default function ProfileGallery({ photos = [] }) {
  const { locale } = useLocale();
  const gallery = Array.isArray(photos) ? photos.filter(Boolean) : [];

  if (!gallery.length) return null;

  return (
    <>
      <Typography variant="subtitle1" fontWeight={800} sx={{ mb: 1 }}>
        {getMessage(locale, "profileGallery")}
      </Typography>
      <Grid container spacing={2}>
        {gallery.map((src, index) => (
          <Grid key={`${src}-${index}`} size={{ xs: 12, sm: 6, md: 4 }}>
            <Card variant="outlined" sx={{ borderRadius: 3, height: "100%" }}>
              <CardMedia
                component="img"
                height="180"
                image={src}
                onError={imageFallbackHandler(BANNER_IMAGE_FALLBACK)}
                alt={getMessage(locale, "profileGalleryImageAlt").replace("{number}", String(index + 1))}
                loading="lazy"
                sx={{ objectFit: "cover" }}
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
